export default __webpack_public_path__ + "static/media/Mitra's Mark of Divine Blessings.eb6bfe68.jpg";